export default __webpack_public_path__ + "static/media/circle_green.4e7b90f3.svg";